import { useTranslation } from 'react-i18next';

/** FND-7.2. Shown while `GET /auth/me` decides whether there is a session. */
export function FullPageSpinner(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="flex h-full min-h-screen items-center justify-center" role="status">
      {/*
        `border-t-iscae-500` was the FND-7.1 placeholder blue, a scale DESIGN.md
        superseded and `tailwind.config.js` no longer defines - so the class
        resolved to nothing and the ring had no leading edge to spin.
      */}
      <span className="h-8 w-8 animate-spin rounded-full border-2 border-outline-variant border-t-primary" />
      <span className="sr-only">{t('common.loading')}</span>
    </div>
  );
}
